<script>
    import {_, locale, number} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_('instantUpgradeCastleItemTitle', {
            values: {LEVEL: $number(gameItem.level)},
        });
        itemDetails.description = $_('instantUpgradeCastleItemDescription', {
            values: {LEVEL: $number(gameItem.level)},
        });
        itemDetails.amount = item.amount;
        itemDetails.icon = gameItem.category + gameItem.level;
        itemDetails.rarity = 1;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
